/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessServiceAvailability } from './BusinessServiceAvailability';
import {
    BusinessServiceAvailabilityFromJSON,
    BusinessServiceAvailabilityFromJSONTyped,
    BusinessServiceAvailabilityToJSON,
    BusinessServiceAvailabilityToJSONTyped,
} from './BusinessServiceAvailability';

/**
 * 
 * @export
 * @interface BusinessServiceAvailabilityBody
 */
export interface BusinessServiceAvailabilityBody {
    /**
     * 
     * @type {string}
     * @memberof BusinessServiceAvailabilityBody
     */
    timeZone: string;
    /**
     * 
     * @type {number}
     * @memberof BusinessServiceAvailabilityBody
     */
    suspendUntil?: number;
    /**
     * 
     * @type {Array<BusinessServiceAvailability>}
     * @memberof BusinessServiceAvailabilityBody
     */
    serviceAvailabilities: Array<BusinessServiceAvailability>;
}

/**
 * Check if a given object implements the BusinessServiceAvailabilityBody interface.
 */
export function instanceOfBusinessServiceAvailabilityBody(value: object): value is BusinessServiceAvailabilityBody {
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('serviceAvailabilities' in value) || value['serviceAvailabilities'] === undefined) return false;
    return true;
}

export function BusinessServiceAvailabilityBodyFromJSON(json: any): BusinessServiceAvailabilityBody {
    return BusinessServiceAvailabilityBodyFromJSONTyped(json, false);
}

export function BusinessServiceAvailabilityBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessServiceAvailabilityBody {
    if (json == null) {
        return json;
    }
    return {
        
        'timeZone': json['timeZone'],
        'suspendUntil': json['suspendUntil'] == null ? undefined : json['suspendUntil'],
        'serviceAvailabilities': ((json['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityFromJSON)),
    };
}

export function BusinessServiceAvailabilityBodyToJSON(json: any): BusinessServiceAvailabilityBody {
    return BusinessServiceAvailabilityBodyToJSONTyped(json, false);
}

export function BusinessServiceAvailabilityBodyToJSONTyped(value?: BusinessServiceAvailabilityBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeZone': value['timeZone'],
        'suspendUntil': value['suspendUntil'],
        'serviceAvailabilities': ((value['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityToJSON)),
    };
}

